/**
 * Local desk profile.
 *
 * OptionEngine has no auth layer — the bot is a single-user paper engine — so
 * the identity shown in the shell is static config. Swap this for the user
 * object from a real session once a login lands.
 */
export const PROFILE = {
  name: "Arvind Kumar Singh",
  shortName: "Arvind",
  handle: "@Arvind",
  initial: "A",
} as const;
